import { reportError } from "@dash0/sdk-web"
import { Component, ErrorInfo, ReactNode } from "react"
import { ERROR_FALLBACK_LAYOUT, ErrorFallback } from "./ErrorFallback/ErrorFallback"

type ErrorBoundaryProps = {
  children: ReactNode
  layout: ERROR_FALLBACK_LAYOUT
  resetKey?: string
}

type ErrorBoundaryState = {
  error: Error | null
  resetKey?: string
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null, resetKey: this.props.resetKey }

  static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
    return { error }
  }

  // Navigating away from a crashed page must render the new route instead of the stale fallback.
  static getDerivedStateFromProps(
    props: ErrorBoundaryProps,
    state: ErrorBoundaryState
  ): Partial<ErrorBoundaryState> | null {
    return props.resetKey === state.resetKey ? null : { error: null, resetKey: props.resetKey }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    reportError(error, { componentStack: errorInfo.componentStack })
  }

  render(): ReactNode {
    const { error } = this.state
    const { children, layout } = this.props

    return error ? (
      <ErrorFallback
        error={error}
        layout={layout}
      />
    ) : (
      children
    )
  }
}
